import React from "react";
import { formatNumberWithSpaces } from "../../utils";
import {ProductInterface} from "../../interfaces/product/product.interface";
import {Skeleton} from "./utils/Skeleton";

interface PriceProps {
    product: ProductInterface;
}

export const Price: React.FC<PriceProps> = ({ product }) => {
    return (
        <>
            {product.specialPrice ? (
                <div className="flex flex-wrap md:block items-center font-semibold">
                    {product.needUpdate ? (
                        <>
                            <Skeleton className="w-[145px] h-[26px] mb-1 md:hidden" />
                            <Skeleton className="w-[120px] h-[42px] mb-1 md:block hidden" />
                            <Skeleton className="w-[120px] h-[30px] mb-1 md:block hidden" />
                        </>
                    ) : (
                        <>
                            <p className="text-[20px] md:text-[28px]">
                                {formatNumberWithSpaces(product.specialPrice)} {product.currency}
                            </p>

                            <p className="ml-3 md:ml-0 text-[14px] md:text-[20px] text-gray line-through decoration-[#E73140]">
                                {formatNumberWithSpaces(product.price)} {product.currency}
                            </p>

                            {product.extraText && (
                                <p className="w-full ml-3 md:ml-0 text-[14px] md:text-[20px] text-[#ED2939]">
                                    {product.extraText}
                                </p>
                            )}
                        </>
                    )}
                </div>
            ) : (
                <div className="flex flex-wrap md:block items-center font-semibold">
                    {product.needUpdate ? (
                        <>
                            <Skeleton className="w-[120px] h-[42px] mb-1 md:block hidden" />
                            <Skeleton className="w-[145px] h-[26px] mb-1 md:hidden" />
                        </>
                    ) : (
                        <>
                            <p className="text-[20px] md:text-[28px]">
                                {formatNumberWithSpaces(product.price)} {product.currency}
                            </p>

                            {product.extraText && (
                                <p className="w-full ml-3 md:ml-0 text-[14px] md:text-[20px] text-[#ED2939]">
                                    {product.extraText}
                                </p>
                            )}
                        </>
                    )}
                </div>
            )}
        </>
    );
};